import { ASDataCollections } from "../../../shared/menu-icons/as-data-collections";
import BoltIcon from '@mui/icons-material/Bolt';
import { ParameterTypeValue } from "../../../constants/app-enum";
import './plugin-parameters.scss';
import SheetsOverlay from "../SheetsOverlay/sheets-overlay";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { SearchParameterController } from "../../../controllers/asheetPlugin/search-parameter/search-parameters";
import { getClientDateTime, truncateString } from "../../../shared/code-challanges/code-challanges";
import { CollectionFilter } from "../search-parameters/FilterParameters.js";
import { ASButton } from "../../../shared/as-button/as-button";
import { useMemo } from "react";
import moment from "moment";
import { DEMO_COMPANY_UID } from "../plugin/plugin";
import { getASTenantId } from "../../../shared/local-storage-handler/local-storage-handler";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import MergeCollectionPopup from "../../common/test-collection-popup/test-collection-popup";
import { muiCheckboxStyle } from "../../user-permission/user-permission";

const PluginParameter = (props) => {
    const { handleBack, selectedCollection, setIsAppend, isAppend, 
        state, isLinked, isOpen, activeSheetName, setState, activeSheet, handleRunOrRefresh, filterConfig, openDataVisualizer, openAddNewConnectionDialog, mergedCollectionsData,
        isMergeDataPopupVisible, mergeDataPopupMessage, handleMergePopupClose, isMergeCancelledRef,executeData} = props;
    const selectedTenant = getASTenantId()

    const isDemoCompany = useMemo(() => {
        const result = selectedTenant.toLowerCase().trim() == DEMO_COMPANY_UID.toLowerCase().trim() ? true : false
        return result
    }, [selectedTenant, DEMO_COMPANY_UID])

    const connectionName = useMemo(() => {
        return truncateString(selectedCollection?.connection?.name, 15)
    }, [selectedCollection?.connection?.name])


    const selectedConnectionName = useMemo(() => {
        return truncateString(selectedCollection?.name, 11)
    }, [selectedCollection?.name])

    const groupName = useMemo(() => {
        return truncateString(selectedCollection?.groupName, 13)
    }, [selectedCollection?.groupName])

    const selectedCollectionName = useMemo(() => {
        return truncateString(selectedCollection?.name, 18)
    }, [selectedCollection?.name])

    const formattedTime = () => {
        const lastRenderTime = activeSheet.current?.lastRenderSuccessfulDateTime;
        if (!lastRenderTime) return moment().format('h:mm A');
        const localTime = getClientDateTime(lastRenderTime)


        const momentTime = moment(localTime);
        return momentTime.isSame(moment(), 'day')
            ? momentTime.format('h:mm A')
            : momentTime.format('MMM D, h:mm A');
    }
    let currentCollectionName = null; 
    return (
        <div className="pluginContainer">
            <div className="header-flex">
                <div className="flex">
                    <div>
                        <img src={`/assets/back-button.svg`} alt="Back" style={{ marginLeft: "5px", marginTop: "5px", cursor: "pointer" }}
                            onClick={handleBack} />
                    </div>

                    <div className="source-header">
                        <img
                            src={`../../../assets/${selectedCollection?.connection?.connectionImageIcon}`}
                            alt="Xero"
                        />{' '}
                        <div className="parameter-heading">
                            {connectionName}
                            <ArrowForwardIosIcon />
                            {selectedConnectionName}
                        </div>

                    </div>
                </div>
                {!isDemoCompany &&
                    <div className="add-icon-btn" onClick={openAddNewConnectionDialog}>+</div>
                }
            </div>

            <div className="parameter-container">
                <div>
                    <div className="flex mt-5">
                        <ASDataCollections className="group-image" flag={false} />
                        Group
                    </div>
                    <div className="ml-10 parameter-heading">

                        {groupName}
                        <ArrowForwardIosIcon />
                        {selectedCollectionName}
                    </div>
                </div>

                <div className="collection-params-container">

                    <div style={{ marginInline: '5px' }}>


                        {state?.searchParameters?.map((parameter, index) => {
                            const parameterTypes = Object.values(ParameterTypeValue());

                            if (parameterTypes.includes(parameter.parameterTypeCD)) {
                                let collectionLabel = null;
                                if (!state.combineMergedParameters && state.hasMergeCollections && mergedCollectionsData) {
                                    let collection = mergedCollectionsData.find(col => col.uId === parameter.childCollectionUId) ||
                                        mergedCollectionsData.find(col => col.uId === parameter.collectionUId);
                                    const collectionName = collection?.collectionName || "";

                                    if (collectionName !== currentCollectionName) {
                                        currentCollectionName = collectionName;
                                        collectionLabel = (
                                            <Typography variant="h6" className="collection-label" key={`collection-${collectionName}`}>
                                                {collectionName}
                                            </Typography>
                                        );
                                    }
                                }

                                return (
                                    <div key={`search-param-${parameter.id}-${index}`}>
                                        {collectionLabel}
                                        {index === 0 && (
                                            <div className="parameter-heading mt-5">
                                                <ArrowForwardIosIcon /> Search Parameters
                                            </div>
                                        )}
                                        <SearchParameterController
                                            parameter={parameter}
                                            index={index}
                                            state={state}
                                            setState={setState}
                                            mergedCollectionsData={mergedCollectionsData}
                                            searchOptionsParameters={state?.searchParameters}
                                        />
                                    </div>
                                );
                            }
                            return null;
                        })}

                        {state?.filterSortParameters?.map((parameter, index) => (
                            <div key={`filter-param-${parameter.id}-${index}`}>
                                {/* {index === 0 && (
                                    <div className="filter-header mt-5">
                                        <div className="parameter-heading">
                                            <ArrowForwardIosIcon />Filter/Sort Parameters
                                        </div>
                                        <button onClick={openDataVisualizer}>edit</button>
                                    </div>
                                )} */}
                                <CollectionFilter
                                    parameter={parameter}
                                    index={index}
                                    collectionUId={selectedCollection?.uId}
                                    sheetName={activeSheet?.sheetName}
                                    filterConfig={filterConfig}
                                    openDataVisualizer={openDataVisualizer}
                                />
                            </div>
                        ))}

                        {!state?.filterSortParameters?.length && state?.templateCollectionId && (
                            <div className="filter-header mt-5">
                                <div className="parameter-heading">
                                    <ArrowForwardIosIcon />Select Filter/Sort
                                </div>
                                <button onClick={openDataVisualizer}>edit</button>
                            </div>
                        )}
                        <div style={{ marginLeft: "15px" }}>
                            <FormControlLabel control={
                                <Checkbox
                                    size="small" checked={isAppend} sx={muiCheckboxStyle}
                                    onChange={(e) => setIsAppend(e.target.checked)}
                                />
                            }
                                className='append-checkbox'
                                label="Append data"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "14px",
                                    },
                                }}
                            />
                        </div>
                        {/* <div style={{ marginLeft: "15px" }}>
                            <FormControlLabel control={
                                <Checkbox
                                    size="small" checked={isCreateTemplate} sx={muiCheckboxStyle}
                                    onChange={(e) => setIsCreateTemplate(e.target.checked)}
                                />
                            }
                                className='append-checkbox'
                                label="Create as a Template"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "14px",
                                    },
                                }}
                            />
                        </div> */}
                    </div>
                </div >
                {
                    activeSheetName
                        ? (
                            <div className="details-header">
                                <div className="parameter-heading">
                                    <ArrowForwardIosIcon />{"Detail"}
                                </div>
                                <div className="details-box">
                                    <div className="details-value">
                                        Last run at {formattedTime()} Successfully
                                    </div>
                                    <div className="details-value">
                                        Linked to {activeSheetName}
                                    </div>
                                </div>
                                <div  className ="details-box" style={{ marginTop: "10px" }}>
                                    <button
                                        style={{
                                            background: "none",
                                            border: "none",
                                            color: "#1976d2",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            padding: 0,
                                            fontSize: "14px"
                                        }}
                                        onClick={() => {
                                            executeData({...state, isCreateTemplate:true});
                                        }}
                                    >
                                        Save this as file template
                                    </button>
                                </div>

                            </div>
                              
                        )
                        : null
                }

            </div>

            <div className="run-btn">
                <ASButton
                    primary={true}
                    variant="contained"
                    sx={{ width: "100%" }}
                    onClick={() => handleRunOrRefresh(state)}
                >
                    <BoltIcon sx={{ color: "yellow" }} /> {isLinked ? "REFRESH" : "RUN"}
                </ASButton>
            </div>
            {
                isOpen &&
                <SheetsOverlay
                    connectionIcon={`${selectedCollection?.connection?.connectionImageIcon}`}
                    sheetsIcon={`/assets/google-sheets-icon.png`}
                    property={selectedCollection?.name}
                />
            }

            {isMergeDataPopupVisible &&
                <MergeCollectionPopup
                    isVisible={isMergeDataPopupVisible}
                    messages={mergeDataPopupMessage}
                    onCancel={() => {
                        isMergeCancelledRef.current = true;
                    }}
                    handleMergePopupClose={handleMergePopupClose}
                />}
        </div >
    )
}

export default PluginParameter